<template>
  <v-card
    text
    color="grey lighten-4"
    height="400"
  >
    <v-container fluid fill-height>
      <v-layout row align-center>
        <v-flex
          xs12
          class="display-1 font-weight-light text-xs-center grey--text">
          <div class="display-4 font-weight-light text-xs-center grey--text mb-5">
            <v-icon>poll</v-icon>
          </div>
          No Data
        </v-flex>
      </v-layout>

    </v-container>
  </v-card>
</template>

<script>
  export default {
    name: '',
    data () {
      return {}
    },
    methods: {}
  }
</script>
